import globals from '../Globals.json';
import api from './api';

export const getProducts = () => {
  return api.get(`${globals.api.products}/minified?id_number=32`);
};

export const getStockableProducts = (store_id) => {
  return api.get(
    `${globals.api.products}/minified?paginate=false&append=stock_qty&store_id=${store_id}&filter[is_stockable]=true&id_number=33`
  );
};

export const getProductStockQty = (uuid) => {
  return api.get(`${globals.api.products}/${uuid}?append=stock_qty&id_number=34`);
};

export const getAllProducts = () => {
  return api.get(`${globals.api.products}/minified?paginate=false&id_number=35`);
};
